import { PayHeader } from "../Paymentheader/PayHeader";
import "./credit.css";
import { Button, Card, Result, message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
// import axiosInstance from "../../Redux/axios/AxiosInstance";
import axiosInCar from "../../Redux/axios/AxiosInCar";
import { useState, useEffect } from "react";
import { SaveTransID } from "../../Redux/actions/NumCaration";
export const IciciCarCredit = () => {
  const dispatch = useDispatch();
  const PolicyDwnld = useSelector(
    (state) => state?.cardetail?.createProposal?.data
  );
  const KYCData = useSelector((state) => state?.cardetail?.KycStatus);
  const InsurId = useSelector((state) => state?.cardetail?.carnum);
  const TRID = useSelector((state) => state?.cardetail?.Tid);
  const carNum = useSelector((state) => state?.cardetail?.carnum);
  //let PolicyDwnld = JSON.parse(localStorage.getItem("create_proposal"));
  const [loading, setLoading] = useState(false);
  const [Transaction, setTransaction] = useState("");

  const history = useHistory();
  console.log(PolicyDwnld);

  console.log(KYCData);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams.toString());
    const transactionId = urlParams.get("transaction_id");
    console.log(transactionId);
    dispatch(SaveTransID(transactionId));
    if (transactionId) {
      history.push(`/iciciCarCredit?transaction_id=${transactionId}`);
    }
  }, [TRID, history]);

  const handleKYC = () => {
    setLoading(true);
    let post = {
      insurance_id: InsurId?.car_insurance_id,
      transaction_id: TRID,
    };
    // `v2/car_insurances/${carNum?.car_insurance_id}/insurers/${SelectedQQ?.provider}/pdf_generation`
    axiosInCar
      .post(
        `v2/car_insurances/${carNum?.car_insurance_id}/insurers/icici/pdf_generation`,
        post
      )
      .then((res) => {
        console.log(res);
        let data = res?.data?.policy_pdf_link;
        //dispatch(KYC_Status(data))
        console.log(data);
        if (data) {
          window.open(data, "_blank");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response);
        message.error(err.response.data.error);
        setLoading(false);
      });
  };

  return (
    <>
      <PayHeader />
      <div className="row justify-content-center py-3">
        <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
          <Result
            status="warning"
            title="Verify Your Payment Satus"
            subTitle={`Policy No: ${PolicyDwnld?.policyNumber}`}
            extra={[
              <Button
                loading={loading}
                onClick={handleKYC}
                type="primary"
                key="console"
              >
                Verify Payment Satus
              </Button>,
            ]}
          />
        </Card>
      </div>
      <div className="footter-md-cnfrm">
        <div className="footter-md-1">
          <p>
            Registration No. 742, Registration Code No. IRDA/ DB 797/ 19, Valid
            till 09/06/2024, License category- Direct Broker (Life & General)
          </p>
          <p> solely based on the information received from the insurers.</p>
        </div>
        <div className="footer-md-2">
          <p>@Copyright 2018-2024</p>
          <p>
            <a href="www.VIBE.com">VIBE</a>
          </p>
          <p>All rights reserved</p>
        </div>
      </div>
    </>
  );
};
